"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConnectionMessage = getConnectionMessage;
function getConnectionMessage(address, userId) {
    const nonce = crypto.randomUUID().replaceAll('-', '');
    return {
        nonce,
        message: "Connect Ethereum Wallet\n\n" +
            `Address: ${address}\n` +
            `User ID: ${userId}\n` +
            `Nonce: ${nonce}\n\n` +
            "This is a read-only message and will not trigger any blockchain actions."
    };
}
//# sourceMappingURL=getConnectionMessage.js.map